import i18n from '@i18next/i18n';
import type { CSSProperties } from 'react';

export const OpacityOptions = {
    suffix: '%',
    step: 1,
    min: 0,
    max: 100,
    maxLength: 4,
};

export const ANGLE_MAX = 360;
export const AngleOptions = {
    step: 5,
};

export const ColorOptions = {
    isColorNoAlpha: true,
    recentColorsText: i18n.t('最近使用'),
};

export const COLOR_STYLE: CSSProperties = {
    boxSizing: 'content-box',
    maxHeight: 28,
};

export const COMMON_STYLE: CSSProperties = {
    maxHeight: 28,
};

export const ALIGN_BUTTON_STYLE: CSSProperties = {
    ...COMMON_STYLE,
    minWidth: 46,
};
